var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAngleRightIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 608 1280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 288q0 13 10 23l393 393-393 393c-6.667 6.67-10 14.33-10 23s3.333 16.33 10 23l50 50c6.667 6.67 14.333 10 23 10s16.333-3.33 23-10l466-466q10-10 10-23t-10-23L119 215q-10-10-23-10t-23 10l-50 50q-10 10-10 23"
})));
export default SvgAngleRightIcon;